import { render } from "./DigitalForms.vue?vue&type=template&id=0e327b1b&scoped=true"
import script from "./DigitalForms.vue?vue&type=script&lang=js"
export * from "./DigitalForms.vue?vue&type=script&lang=js"

import "./DigitalForms.vue?vue&type=style&index=0&id=0e327b1b&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e327b1b"]])

export default __exports__